import React from 'react';
import PropTypes from 'prop-types';
import { 
  Box, 
  Typography, 
  IconButton
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { motion } from 'framer-motion';

const AppointmentsHeader = ({ title, onBack }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Box sx={{ 
        mb: 4, 
        display: 'flex', 
        alignItems: 'center',
        borderRadius: 2,
        p: 2
      }}>
        <IconButton 
          onClick={onBack} 
          sx={{ 
            mr: 2,
            bgcolor: 'primary.light',
            color: 'primary.contrastText',
            '&:hover': {
              bgcolor: 'primary.main',
            }
          }}
          aria-label="back to calendar"
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography 
          variant="h4" 
          component="h1" 
          sx={{ 
            fontWeight: 'bold',
            color: 'primary.main'
          }}
        >
          {title}
        </Typography>
      </Box>
    </motion.div>
  );
};

AppointmentsHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired
};

export default AppointmentsHeader; 